import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TinyAlertComponent } from './tiny-alert.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [TinyAlertComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [TinyAlertComponent]
})
export class TinyAlertModule { }
